type StyleProps = {
  color: string;
  hideTriangleOnMobile?: boolean;
  isMobile?: boolean;
};

const useStyles = (props: StyleProps) => ({
  container: {
    backgroundColor: props.color,
    borderRadius: '43px 0px 0px 43px',
    maxWidth: 'fit-content',
    height: 'fit-content',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
  } as React.CSSProperties,

  text: {
    color: '#000',
    fontSize: '12px',
    textAlign: 'center',
    paddingLeft: '5px',
  } as React.CSSProperties,

  icon: {
    width: '20px',
    height: '20px',
    marginLeft: '5px',
  } as React.CSSProperties,

  triangle: {
    width: '0',
    height: '0',
    borderRight: '8px solid transparent',
    borderTop: '8px solid #595959',
    position: 'absolute',
    bottom: '-8px',
    right: '0px',
    display: props.isMobile
      ? props.hideTriangleOnMobile
        ? 'none'
        : 'block'
      : 'block',
  } as React.CSSProperties,
});

export default useStyles;
